// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as userReducer } from './user';
import { reducer as toastsReducer } from './toasts';
import { reducer as saveFormDataReducer } from './saveFormData';
import { reducer as loadFileAssociationsReducer } from './loadFileAssociations';
import { reducer as loadFormDataReducer } from './loadFormData';
import { reducer as cleanFormDataReducer } from './cleanFormData';
import { reducer as getPdfCommonReducer } from './getPdfCommon';
import { reducer as getPdfSavingPlanReducer } from './getPdfSavingPlan';
import { reducer as getBranchOfficeReducer } from './getBranchOffice';
import { reducer as getLocationsReducer } from './getLocations';
import { reducer as addMenuPresupuestoUltimoEditadoReducer } from './addMenuPresupuestoUltimoEditado';
import { reducer as removeMenuPresupuestoUltimoEditadoReducer } from './removeMenuPresupuestoUltimoEditado';
import { reducer as getCanDeleteReducer } from './getCanDelete/reducer';
import { reducer as getCurrencySymbolReducer } from './getCurrencySymbol';
import { reducer as createFileNewProductFromMasterReducer } from './createFileNewProductFromMaster';
import { reducer as responsiveReducer} from './responsiveReducer'
import { reducer as comeFromSalesforce } from './comeFromSalesforce'
import { reducer as getPlansReducer } from './getPlans';
import { reducer as saveClientDataReducer } from './saveClientData';
import { reducer as saveLeadDataForCatalogReducer } from './saveLeadDataForCatalog';
import { reducer as customFiltersReducer } from './getCustomFilters'
import { reducer as manageModalData} from './manageModalData'

import { LOGOUT_USER } from './constants'
import { reducer as loggerReducer } from './logger';

const reducers = [
  userReducer,
  toastsReducer,
  saveFormDataReducer,
  loadFileAssociationsReducer,
  loadFormDataReducer,
  cleanFormDataReducer,
  getPdfCommonReducer,
  getPdfSavingPlanReducer,
  getBranchOfficeReducer,
  loggerReducer,
  getLocationsReducer,
  addMenuPresupuestoUltimoEditadoReducer,
  removeMenuPresupuestoUltimoEditadoReducer,
  getCanDeleteReducer,
  getCurrencySymbolReducer,
  createFileNewProductFromMasterReducer,
  responsiveReducer,
  comeFromSalesforce,
  getPlansReducer,
  saveClientDataReducer,
  saveLeadDataForCatalogReducer,
  customFiltersReducer,
  manageModalData
];

export default function reducer(state = initialState, action = {}) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}
